import _ from 'lodash';

const sources = {
  altom: {
    lineups: true,
    sport: 'football',
  },
  cartola: {
    autoFixtures: true,
    lineups: true,
    sport: 'football',
  },
  fbRefFootball: {
    sport: 'football',
    csvOnly: true,
    csvForPlayer: true,
  },
  fdAmericanFootball: {
    lineups: true,
    prices: true,
    sport: 'american_football',
    flexibleUids: true,
  },
  fdMajorLeagueBaseball: {
    lineups: true,
    prices: true,
    sport: 'baseball',
    auto: true,
    flexibleUids: true,
  },
  fdMixedMartialArts: {
    lineups: true,
    sport: 'mma',
    auto: true,
    flexibleUids: true,
  },
  fdNationalHockeyLeague: {
    lineups: true,
    prices: true,
    sport: 'hockey',
    auto: true,
    flexibleUids: true,
  },
  fdNationalBasketballAssociation: {
    projections: true,
    lineups: true,
    prices: true,
    sport: 'basket',
    auto: true,
    flexibleUids: true,
  },
  fdNcaa: {
    lineups: true,
    sport: 'basket',
    auto: true,
    flexibleUids: true,
  },
  fdGolf: {
    projections: true,
    lineups: true,
    sport: 'golf',
    auto: true,
    canOverwritePlayer: ['shirt'],
    flexibleUids: true,
  },
  veikkaus: {
    lineups: true,
    sport: 'football',
  },
  transfermarkt: {
    sport: 'football',
  },
  wch: {
    sport: 'hockey',
    lineups: true,
  },
  gshockey: {
    sport: 'hockey',
    lineups: true,
    stats: true,
    auto: true,
    noTeams: ['1002'],
  },
  gsbasket: {
    sport: 'basket',
    lineups: true,
    auto: true,
    old: true,
    noTeams: ['1049', 'ncaa'],
    flexibleUids: true,
  },
  gsfootball: {
    sport: 'football',
    lineups: true,
    stats: true,
    auto: true,
  },
  globalhockey: {
    sport: 'hockey',
  },
  atg: {
    sport: 'horses',
    lineups: true,
    auto: true,
  },
  isa: {
    sport: 'hockey',
    lineups: true,
    auto: true,
  },
  cricketapi: {
    name: 'Cricket API',
    sport: 'cricket',
    lineups: true,
    token: true,
    auto: true,
  },
  cricketapi4: {
    name: 'Cricket API v4',
    sport: 'cricket',
    lineups: true,
    token: true,
    auto: true,
  },
  cricketapi5: {
    name: 'Cricket API v5 (Roanuz)',
    sport: 'cricket',
    lineups: true,
    token: true,
    auto: true,
    projections: true,
  },
  cricketapiKabaddi: {
    name: 'Cricket API (Kabaddi)',
    sport: 'kabaddi',
    lineups: true,
    token: true,
    auto: true,
  },
  abiosCsgo: {
    name: 'Abios CS:GO',
    sport: 'csgo',
    lineups: true,
    token: true,
    auto: true,
  },
  gamescorekeeperCsgo: {
    name: 'Gamescorekeeper CS:GO',
    sport: 'csgo',
    lineups: true,
    token: true,
    auto: true,
  },
  gamescorekeeperLol: {
    name: 'Gamescorekeeper LOL',
    sport: 'lol',
    lineups: true,
    token: true,
    auto: true,
  },
  opendota: {
    name: 'Opendota Dota',
    sport: 'dota2',
    lineups: true,
    token: true,
    auto: true,
    flexibleUids: true,
  },
  sportmonksFootball: {
    name: 'Sportmonks Football v2',
    sport: 'football',
    lineups: true,
    token: true,
    auto: true,
    flexibleUids: true,
  },
  sportmonksFootball3: {
    name: 'Sportmonks Football v3',
    sport: 'football',
    lineups: true,
    token: true,
    auto: true,
  },
  sportradarHandball: {
    name: 'Sportradar Handball',
    sport: 'handball',
    lineups: true,
    token: true,
    auto: true,
    flexibleUids: true,
  },
  rocketRunout: {
    name: 'Rocket Runout',
    sport: 'rocket_runout',
    lineups: true,
    auto: true,
  },
  csv: {
    canOverwritePlayer: true,
  },
  custom: {
    canOverwritePlayer: true,
  },
};

for (const [id, source] of Object.entries(sources)) {
  source.id = id;
  source.path = _.kebabCase(id);
  if (!source.name) source.name = _.startCase(id);
}

export default sources;
